import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FieldOkItemComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-field-ok-data-view',
  imports: [CommonModule],
  templateUrl: './abcanalyse.list-view.html',
  styleUrls: ['./abcanalyse.list-view.scss'],
})
export class AbcAnalyseListView implements FieldOkItemComponent<any> {
  @Input() item: any;
}
